import { render, staticRenderFns } from "./ProfilPassages.vue?vue&type=template&id=50de728b&scoped=true&"
import script from "./ProfilPassages.vue?vue&type=script&lang=js&"
export * from "./ProfilPassages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de728b",
  null
  
)

export default component.exports